import { Navigate, Outlet } from "react-router-dom";
import Authleft from "src/components/Authleft";
import { useAuth } from "src/providers/AuthProvider";

const PublicRoute = () => {
	const { isAuthenticated } = useAuth();

	if (isAuthenticated) return <Navigate to="/dashboard" />;

	return (
		<div className="mainAppWrapper tw-grid md:tw-grid-cols-[2fr,3fr]">
			<Authleft />

			<div className="md:tw-px-14 md:tw-py-20 tw-px-8 tw-py-12 tw-grid tw-place-items-center">
				<Outlet />
			</div>
		</div>
	);
};

export default PublicRoute;
